import React from 'react';
import { Hero } from '../components/home/Hero';
import { ContainerJourney } from '../components/home/ContainerJourney';
import { AdvisoryBar, QuickLinks, WhySudvik, Services, StatsBand, TradeLanes, BulkSection, PortalSection, IndustriesStrip, PeopleSection, SustainabilityTeaser, Insights, CtaBand } from '../components/home/Sections';

function HomePage() {
  return (
    <div className="bg-white" data-testid="home-page">
      <AdvisoryBar />
      <Hero />
      <QuickLinks />
      <WhySudvik />
      <Services />
      <ContainerJourney />
      <StatsBand />
      <TradeLanes />
      <BulkSection />
      <PortalSection />
      <IndustriesStrip />
      <PeopleSection />
      <SustainabilityTeaser />
      <Insights />
      <CtaBand />
    </div>
  );
}

export default HomePage;
